import React from 'react';
import Modal from 'react-modal';

import modal from '../../../definitions/Modal';
import { formatCustom, formatTime } from '../../../utils/TimeUtils';

import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import Loader from '../../Loader';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import { FormattedMessage } from 'react-intl';
import OTButtonGroup from '../../tag/OTButtonGroup';

const style = modal({ content: { width: '500px' } });

let { id: module_id } = module;

const AppointmentRescheduleConfirmModal = ({
  modalIsOpen,
  closeModal,
  confirmTime,
  isRescheduling,
  item,
  orgItem,
}) => {
  let loader = null,
    _location = null;
  let { location, dateStart, dateEnd } = item;

  if (isRescheduling) {
    loader = <Loader />;
  }

  if (location) {
    _location = getDepartmentDisplay(location);
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={style}
      contentLabel=""
    >
      <Row>
        <Span>
          <h4 className="float-left ot-modal__title">
            <FormattedMessage id={`${module_id}.reserve.new.time`} />
          </h4>
        </Span>
      </Row>
      <Row>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">
            <FormattedMessage id={`${module_id}.location`} />
          </span>
        </Span>
        <Span len="8" sm-len="12">
          <span className="appointment-modal-text">{_location}</span>
        </Span>
      </Row>
      <Row>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">
            <FormattedMessage id={`${module_id}.old.time`} />
          </span>
        </Span>
        <Span len="8" sm-len="12">
          <span className="appointment-modal-text">
            {' '}
            {`${formatCustom(orgItem.dateStart, 'DD. MMMM')}ta klo ${formatTime(
              orgItem.dateStart
            )} - ${formatTime(orgItem.dateEnd)}`}{' '}
          </span>
        </Span>
      </Row>
      <Row style={{ paddingBottom: '15px' }}>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">
            <FormattedMessage id={`${module_id}.time`} />
          </span>
        </Span>
        <Span len="8" sm-len="12">
          <span className="appointment-modal-text">
            {' '}
            {`${formatCustom(dateStart, 'DD. MMMM')}ta klo ${formatTime(
              dateStart
            )} - ${formatTime(dateEnd)}`}{' '}
          </span>
        </Span>
      </Row>
      <Row>{loader}</Row>
      <Row>
        <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
          <OTButton
            disabled={isRescheduling}
            color={'gray'}
            onClick={closeModal}
            message={'back'}
          />
          <OTButton
            disabled={isRescheduling}
            onClick={confirmTime}
            message={'OK'}
          />
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

Modal.setAppElement('body');
export default AppointmentRescheduleConfirmModal;
